const headRowsTypeService = {
  actions:'Ações',
  name: 'Tipo de Serviço'
};

export default headRowsTypeService;
